
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.522 14.4s-.469-3.31-1.913-4.762c-1.828-1.913-3.872-1.922-4.809-2.035-6.712-.487-16.79-.487-16.79-.487h-.02s-10.077 0-16.79.487c-.938.113-2.981.122-4.81 2.035C.948 11.09.488 14.4.488 14.4S0 18.29 0 22.172v3.637c0 3.882.478 7.772.478 7.772s.469 3.31 1.903 4.763c1.828 1.912 4.228 1.847 5.297 2.053 3.844.366 16.322.478 16.322.478s10.087-.019 16.8-.497c.938-.112 2.981-.122 4.81-2.034 1.443-1.453 1.912-4.763 1.912-4.763S48 29.701 48 25.81v-3.637c0-3.881-.478-7.772-.478-7.772zM19.04 30.225v-13.49l12.965 6.768-12.965 6.722z","fill":"currentColor"}})])
          )
        }
      }
    